<template>
  <q-card flat>
    <q-card-section>
      <div class="text-h6">{{ $t('personal_data') }}</div>
    </q-card-section>
    <q-form @submit="onSave">
      <q-card-section class="q-pt-none row q-col-gutter-md">
        <div class="col-6">
          <q-input outlined :label="$t('name') + '*'" v-model="affiliateData.name" type="text" lazy-rules :rules="[isRequired]" />
        </div>
        <div class="col-6">
          <q-input
            outlined
            :label="$t('last_name') + '*'"
            v-model="affiliateData.last_name"
            type="text"
            lazy-rules
            :rules="[isRequired]"
          />
        </div>
        <div class="col-6">
          <q-input
            outlined
            :label="$t('company') + '*'"
            v-model="affiliateData.business_name"
            type="text"
            :hint="$t('if_not_company')"
            lazy-rules
            :rules="[isRequired]"
          />
        </div>
        <div class="col-6">
          <q-input
            outlined
            label="E-mail*"
            disabled
            readonly
            v-model="affiliateData.email"
            type="email"
            :hint="$t('email_to_activate')"
          />
        </div>
        <div class="col-6">
          <q-input
            outlined
            :label="$t('phone') + '*'"
            v-model="affiliateData.phone_number"
            mask="+## ## #####-####"
            unmasked-value
            hint="Ex. +55 21 99999-9999"
            lazy-rules
            :rules="[isRequired]"
          />
        </div>
      </q-card-section>
      <q-card-actions vertical align="right">
        <q-btn class="q-px-md" color="positive" no-caps type="submit" unelevated :label="$t('save')" />
      </q-card-actions>
    </q-form>
  </q-card>
</template>

<script>
import AffiliateService from '../../../services/AffiliateService';
import AffiliateMixin from '../../../mixins/AffiliateMixin';

export default {
  props: {
    id: {
      type: [String, Number],
      require: true
    }
  },
  mixins: [AffiliateService, AffiliateMixin],
  name: 'AffiliateContentPersonalData',
  data() {
    return {
      affiliateData: {
        name: null,
        business_name: null,
        last_name: null,
        email: null,
        phone_number: null
      }
    };
  },

  methods: {
    async setupAffiliateData(id) {
      this.onLoading(true);
      try {
        const { data, status } = await this.getAffiliateData(id);
        if (status === 200) {
          this.affiliateData = data;

          if (this.affiliateData.last_name === null) {
            let nameFormat = this.affiliateData.name.split(/\s* \s*/);

            this.affiliateData.name = nameFormat[0];
            this.affiliateData.last_name = nameFormat[1];
          }
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async onSave() {
      this.onLoading(true);
      try {
        const { data, status } = await this.editAffiliateData(this.id, this.affiliateData);
        if (status === 200) {
          // eslint-disable-next-line no-unused-vars
          let response = data;
          this.successNotify(this.$t('data_updated_successfully'));
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    }
  },
  created() {
    this.setupAffiliateData(this.id);
  }
};
</script>
